import { downloadCsv, get, patch } from '@/api/base'

const containerGroupsApi = {
  get: async groupUuid => {
    const response = await get({ path: `container_groups/${groupUuid}` })
    return response.success ? { ...response, containerGroup: response.data.container_group } : response
  },
  getAll: async params => {
    const response = await get({
      path: 'container_groups',
      params: { ...params },
    })
    return response.success
      ? {
          ...response,
          containerGroups: response.data.container_groups,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getFromSearch: async (searchText, params) => {
    const response = await get({
      path: 'container_groups/search',
      params: { live_search: searchText, ...params },
    })
    return response.success ? response.data.container_groups : null
  },
  getAllGeoJson: async params => {
    const response = await get({
      path: `container_groups_geojson`,
      params,
    })
    return response.success ? response.data : null
  },
  update: async (groupUuid, params) => {
    const response = await patch({
      path: `container_groups/${groupUuid}`,
      params: { ...params },
    })
    return response.success ? { ...response, containerGroup: response.data.container_group } : response
  },
  downloadCsv: async companyUuid => {
    await downloadCsv({
      path: 'container_groups/csv',
      params: {
        company_uuid: companyUuid,
      },
    })
  },
}

export default containerGroupsApi
